import Vue from 'vue'
import VueRouter from 'vue-router'
import auth from '../middleware/auth';
import log from '../middleware/log';

Vue.use(VueRouter)

let routes = [
	{
		path: '*',
		component: () => import('../views/404.vue'),
	},
	{
		path: '/403',
		component: () => import('../views/403.vue'),
	},
	{
		path: '/',
		name: 'خانه',
		redirect: '/dashboard',
	},
	{
		path: '/dashboard',
		name: 'داشبورد',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/Dashboard.vue'),
	},
	{
		path: '/sign-in',
		name: 'login',
		component: () => import('../views/Sign-In.vue'),
	},
	{
		path: '/users/list',
		name: 'لیست کاربران',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/users/list.vue'),
	},
	{
		path: '/users/add',
		name: 'افزودن کاربر',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/users/add.vue'),
	},
	{
		path: '/users/edit/:id',
		name: 'ویرایش کاربر',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/users/edit.vue'),
	},
	{
		path: '/users/detail/:id',
		name: 'تراکنش های کاربر',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/users/detail.vue'),
	},
	{
		path: '/roles/list',
		name: 'لیست سطوح دسترسی',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/roles/list.vue'),
	},
	{
		path: '/roles/add',
		name: 'افزودن سطوح دسترسی',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/roles/add.vue'),
	},
	{
		path: '/roles/edit/:id',
		name: 'ویرایش سطوح دسترسی',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/roles/edit.vue'),
	},
	{
		path: '/categories/list',
		name: 'لیست دسته بندی ها',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/categories/list.vue'),
	},
	{
		path: '/categories/add',
		name: 'افزودن دسته بندی ها',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/categories/add.vue'),
	},
	{
		path: '/categories/edit/:id',
		name: 'ویرایش دسته بندی ها',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/categories/edit.vue'),
	},
	{
		path: '/specifications/list',
		name: 'لیست مشخصات',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/specifications/list.vue'),
	},
	{
		path: '/specifications/add',
		name: 'افزودن مشخصات',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/specifications/add.vue'),
	},
	{
		path: '/specifications/edit/:id',
		name: 'ویرایش مشخصات',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/specifications/edit.vue'),
	},
	{
		path: '/products/list',
		name: 'لیست آگهی ها',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/products/list.vue'),
	},
	{
		path: '/products/add',
		name: 'افزودن آگهی ها',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/products/add.vue'),
	},
	{
		path: '/products/edit/:id',
		name: 'ویرایش آگهی ها',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/products/edit.vue'),
	},
	{
		path: '/orders/list',
		name: 'لیست سفارشات ',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/orders/list.vue'),
	},
	{
		path: '/orders/wallet',
		name: 'لیست شارژ کیف پول ',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/orders/wallet.vue'),
	},
	{
		path: '/orders/return',
		name: 'لیست درخواست های مرجوعی سفارشات ',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/orders/return.vue'),
	},
	{
		path: '/orders/detail/:id',
		name: 'مشاهده سفارش ',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/orders/edit.vue'),
	},
	{
		path: '/seminars/list',
		name: 'لیست  سمینار ها',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/seminars/list.vue'),
	},
	{
		path: '/seminars/add',
		name: 'افزودن  سمینار ها',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/seminars/add.vue'),
	},
	{
		path: '/seminars/edit/:id',
		name: 'ویرایش  سمینار ها',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/seminars/edit.vue'),
	},
	{
		path: '/seminars/sans/:id',
		name: 'سانس  سمینار ها',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/seminars/sans.vue'),
	},
	{
		path: '/seminars/reports',
		name: 'گزارشات  سمینار ها',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/seminarReports/list.vue'),
	},
	{
		path: '/seminars/callcenter',
		name: 'کال سنتر  سمینار ها',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/seminars/callcenter.vue'),
	},
	{
		path: '/seminars/reports/:id',
		name: 'جزییات گزارش  سمینار ',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/seminarReports/report.vue'),
	},
	{
		path: '/seminars/survey/:id',
		name: 'نظرسنجی سمینار ها',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/seminars/survey.vue'),
	},
	{
		path: '/seminars/answers/:id',
		name: 'پاسخ نظرسنجی سمینار ها ' ,
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/seminars/answers.vue'),
	},
	{
		path: '/seminars/guests/:id',
		name: 'مهمانان سمینار ',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/seminars/guests.vue'),
	},

	{
		path: '/seminars/allGuests/:id',
		name: 'مهمانان  ',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/seminars/guestsSeminar.vue'),
	},
	{
		path: '/seminars/gifts/:id',
		name: 'جوایز سمینار ',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/seminars/gifts.vue'),
	},
	{
		path: '/financials/list',
		name: ' لیست کاربران ',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/financials/list.vue'),
	},
	{
		path: '/financials/transactions/:id',
		name: ' لیست تراکنش های کاربر ',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/financials/transactions.vue'),
	},
	{
		path: '/financials/transactions',
		name: ' لیست تراکنش  ها ',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/financials/transactionList.vue'),
	},
	{
		path: '/financials/withdraw',
		name: ' لیست درخواست های برداشت ',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/financials/withdraw.vue'),
	},
	{
		path: '/financials/report',
		name: '    گزارشات مالی ',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/financials/report.vue'),
	},
	{
		path: '/financials/revenue',
		name: '    گزارشات کارمزد ها ',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
		},
		component: () => import('../views/financials/revenue.vue'),
	},
	{
		path: '/financials/providersReport',
		name: '    گزارش خدمات دهندگان ',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
		},
		component: () => import('../views/financials/providersReport.vue'),
	}
	,	
	{
		path: '/financials/excelReports',
		name: ' لیست گزارشات اکسل  ',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/financials/excelReportsList.vue'),
	},
	{
		path: '/setting/main',
		name: '     تنظیمات اصلی ',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/setting/main.vue'),
	},
	{
		path: '/requests/messages',
		name: 'درخواست های پیامک ',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/requests/messages.vue'),
	},
	{
		path: '/requests/banners',
		name: 'درخواست های بنر ',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/requests/banners.vue'),
	},
	{
		path: '/requests/offers',
		name: '  پیشنهاد شگفت انگیز ',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/requests/offers.vue'),
	},
	{
		path: '/requests/cancellation',
		name: 'درخواست های لغو عضویت ',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/requests/cancellation.vue'),
	},
	{
		path: '/units/list',
		name: 'لیست واحد ها',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/units/list.vue'),
	},
	{
		path: '/units/add',
		name: 'افزودن واحد ها',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/units/add.vue'),
	},
	{
		path: '/units/edit/:id',
		name: 'ویرایش واحد ها',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/units/edit.vue'),
	},
	{
		path: '/banners/setting',
		name: 'تنظیمات بنر ها',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/banners/setting.vue'),
	},
	{
		path: '/banners/list',
		name: 'لیست بنر ها',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/banners/list.vue'),
	},
	{
		path: '/banners/add',
		name: 'افزودن بنر ها',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/banners/add.vue'),
	},
	{
		path: '/banners/edit/:id',
		name: 'ویرایش بنر ها',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/banners/edit.vue'),
	},
	{
		path: '/tickets/list',
		name: 'لیست تیکت ها',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/tickets/list.vue'),
	},
	{
		path: '/tickets/detail/:id',
		name: 'جزییات تیکت ها',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/tickets/detail.vue'),
	},
	{
		path: '/send/sms',
		name: 'ارسال پیامک ',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/send/sms.vue'),
	},
	{
		path: '/send/notification',
		name: 'ارسال نوتیفیکیشن ',
		layout: "dashboard",
		meta: {
			middleware: [auth, log],
	    },
		component: () => import('../views/send/notification.vue'),
	}
]

function addLayoutToRoute( route, parentLayout = "default" )
{
	route.meta = route.meta || {} ;
	route.meta.layout = route.layout || parentLayout ;
	
	if( route.children )
	{
		route.children = route.children.map( ( childRoute ) => addLayoutToRoute( childRoute, route.meta.layout ) ) ;
	}
	return route ;
}

routes = routes.map( ( route ) => addLayoutToRoute( route ) ) ;

const router = new VueRouter({
	base: process.env.BASE_URL,
	mode: 'history',
	routes,
	scrollBehavior (to, from, savedPosition) {
		if ( to.hash ) {
			return {
				selector: to.hash,
				behavior: 'smooth',
			}
		}
		return {
			x: 0,
			y: 0,
			behavior: 'smooth',
		}
	}
})

function nextFactory(context, middleware, index) {
	  const subsequentMiddleware = middleware[index];

	  if (!subsequentMiddleware) return context.next;
	
	  return (...parameters) => {
	    context.next(...parameters);
	    const nextMiddleware = nextFactory(context, middleware, index + 1);
	    subsequentMiddleware({ ...context, next: nextMiddleware });
	  };
	}
	router.beforeEach((to, from, next) => {
	  if (to.meta.middleware) {
	    const middleware = Array.isArray(to.meta.middleware)
	      ? to.meta.middleware
	      : [to.meta.middleware];
	    const context = {
	      from,
	      next,
	      router,
	      to,
	    };
	    const nextMiddleware = nextFactory(context, middleware, 1);
	
	    return middleware[0]({ ...context, next: nextMiddleware });
	  }
	  return next();
	});

export default router
